import defaultState from "./state";

const datosEmpresaReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_DATOS_EMPRESA": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "SET_COMPANY_DATA": {
      return Object.assign({}, state, {
        companyDetails: action.data,
      });
    }
    case "SET_SUCURSAL_DATA": {
      return Object.assign({}, state, {
        sucursalDetails: action.data,
      });
    }
    default:
      return state;
  }
};

export default datosEmpresaReducer;
